import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/** The app's normal "page not found" screen (also what non-admins see at /admin). */
export function NotFoundPage({ embedded = false }: { embedded?: boolean }) {
  // inside another layout (the admin console) it fills that layout's <main>
  const Root = embedded ? "div" : "main";

  return (
    <Root
      className={cn(
        "flex flex-col items-center justify-center gap-3 px-4 text-center",
        embedded ? "min-h-[60dvh]" : "min-h-dvh",
      )}
    >
      <p className="tabular text-sm font-medium text-muted-foreground">404</p>
      <h1 className="text-lg font-semibold tracking-tight">Page not found</h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        The page you're looking for doesn't exist or has moved.
      </p>
      <div className="mt-2 flex gap-2">
        <Button variant="primary" onClick={() => window.location.assign("/")}>
          Go home
        </Button>
      </div>
    </Root>
  );
}
